import styled from '@emotion/styled'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from '@dnd-kit/core'
import {
  useSortable,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { restrictToVerticalAxis, restrictToParentElement } from '@dnd-kit/modifiers'
import { CSS } from '@dnd-kit/utilities'
import { Colors } from 'src/components/theme'

const SortableItemWrapper = styled.div<{ dragging: 1 | 0 }>`
  cursor: grab;
  :active {
    cursor: grabbing;
  }
  & > div {
    box-shadow: ${(props) => (props.dragging ? Colors.BOX_SHADOW : 'none')};
    cursor: grab;
    :active {
      cursor: grabbing;
    }
  }
`

type SortableItemProps = {
  id: string
  children: React.ReactNode
}
export function SortableItem(props: SortableItemProps) {
  const { id, children } = props
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id })

  const style = {
    mouseEvents: 'none',
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 1 : 0,
    opacity: isDragging ? 0.8 : 1,
  }

  return (
    <SortableItemWrapper dragging={isDragging ? 1 : 0} ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {children}
    </SortableItemWrapper>
  )
}

type SortableProviderProps = {
  items: any[]
  onDragEnd: (event: DragEndEvent) => void
  children: React.ReactNode
}
export const SortableProvider = (props: SortableProviderProps) => {
  const { items, children, onDragEnd } = props
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )
  return (
    <DndContext
      modifiers={[restrictToParentElement, restrictToVerticalAxis]}
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={onDragEnd}>
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        {children}
      </SortableContext>
    </DndContext>
  )
}
